module.exports = __webpack_public_path__ + "img/Country1-2.5e97ab31.png";